// removed by extract-text-webpack-plugin
module.exports = {"pgx-modal":"pgx-modal","pgx-modal-title":"pgx-modal-title","content":"content","ant-modal-header":"ant-modal-header","ant-modal-body":"ant-modal-body","warning-content":"warning-content","normal-message":"normal-message","tiny-message":"tiny-message","ant-modal-close":"ant-modal-close","ant-modal-footer":"ant-modal-footer","pgx-modal-close":"pgx-modal-close","cancel-btn":"cancel-btn","ok-btn":"ok-btn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/sass/modal.scss
// module id = 250
// module chunks = 0